import { render, staticRenderFns } from "./GTableChart.vue?vue&type=template&id=1b11c479&"
import script from "./GTableChart.vue?vue&type=script&lang=js&"
export * from "./GTableChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports